import { Ref, useEffect } from 'react'

import { isFunction } from 'lodash'
import { StoreApi } from 'zustand'

export const useStoreImperative = <T>(
  ref: Ref<T> | undefined | null,
  store: StoreApi<T>
) => {
  useEffect(() => {
    const updateRef = (state: T) => {
      // eslint-disable-next-line
      if (isFunction(ref)) {
        ref(state)
      } else if (ref) {
        ref.current = state
      }
    }
    updateRef(store.getState())
    return store.subscribe(updateRef)
  }, [store, ref])
}
